import React from "react";

export function StylesPrice() {
  const
    image =
      `url("data:image/svg+xml;utf8,<svg width='20' height='20' viewBox='3 4 14 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M14.4998 7.08414C14.0782 6.70529 13.4161 6.70524 12.9945 7.08418L8.6683 10.9724C8.65262 10.9865 8.62365 11.0003 8.58408 11.0003C8.54452 11.0003 8.51553 10.9865 8.49984 10.9724L7.00548 9.62931C6.5839 9.25041 5.92173 9.25041 5.50015 9.62931L5.34089 9.77245C4.88637 10.1809 4.88638 10.869 5.34088 11.2775L7.83141 13.5158C8.25299 13.8947 8.91516 13.8947 9.33674 13.5158L14.6591 8.73232C15.1136 8.32384 15.1136 7.63583 14.6591 7.22733L14.4998 7.08414Z' fill='white'/></svg>")`

  return (
    <style>{
`#plan { gap: 12px; margin-top: 0 !important }
#plan .nowrap big { font-size: 40px; font-weight: 700; position: relative; top: -2px }
#plan .promo-outer { position: absolute; left: 0; top: 0; width: 100%; background-color: #5775C8; text-align: center; font-size: 12px; border-radius: 8px 8px 0 0; }

#plan .block-plan { background-color: var(--surface-card); padding: 0 }
#plan .block-plan:not(.active) { border-color: var(--surface-card) }
#plan .block-plan .promo { display: none }
#plan .block-plan .promo-inner { background-color: #2E4071; white-space: nowrap; color: #9DB4F4; padding: 2px 8px; font-size: 12px; font-weight: 400; display: inline-block }
#plan .block-plan .item { gap: 1rem; padding: 12px 20px }
#plan .block-plan .note { color: rgba(255, 255, 255, 0.4) }

#plan .block-plan.active { background-color: #283145 }
#plan .block-plan.active .promo-inner { background-color: #5775C8; color: #fff }

#plan .block-plan:nth-child(3) .item { padding-top: 36px }

#plan .custom-input input[type="radio"].checked::before {
  background-size: contain; background-repeat: no-repeat; width: 100%; height: 100%;
  background-image: ${image}
}

#plan .block-plan:nth-child(3) .item { flex-wrap: wrap }
#plan .block-plan:nth-child(3) .item > .w-100.text-start { width: auto }
#plan .block-plan:nth-child(3) .item > .w-100.text-start + div { margin-left: auto }`
    }</style>
  )
}
